export default "assets/images/icons/time-a23d412d.svg";